<section>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="modal fade" id="selectpg-popup" tabindex="-1" aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-body mdltp-txtcont">
                                <div *ngIf="!resetPassword && !otpPassword">
                                    <div class="d-flex justify-content-center">
                                        <button type="button"
                                            class="upload-btnactyvtyside btn btn-primary m-2 btn-style"
                                            (click)="resetPassword = true">
                                            CHANGE USING EXISTING PASSWORD
                                        </button>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <button type="button" class="upload-btnactyvtyside btn-style"
                                            (click)="otpPassword = true">
                                            CHANGE USING OTP
                                        </button>
                                    </div>
                                </div>
                                <div class="my-4" *ngIf="resetPassword">
                                    <h1 class="header-style">Change Password Using Existing Credential</h1>
                                    <div class="change-password my-3 mx-5">
                                        <div class="col-12 d-flex flex-column mx-4">
                                            <div class="mb-3">
                                                <label class="form-label label-cnt">Current Password</label>
                                                <input class="form-control inpt-cnt" type="password" />
                                            </div>
                                            <div class="mb-3 d-flex">
                                                <div>
                                                    <label class="form-label label-cnt">New Password</label>
                                                    <input class="form-control inpt-cnt"
                                                        type="{{ newPassword ? 'password' : 'text' }}" />
                                                </div>
                                                <div>
                                                    <span (click)="newPasswordVisibility()">
                                                        <i class="fas mx-3 eye-icon" [class.fa-eye]="!newPassword"
                                                            [class.fa-eye-slash]="newPassword"></i>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="d-flex">
                                                <div>
                                                    <label class="form-label label-cnt"> Confirm Password</label>
                                                    <input type="{{ confirmPassword ? 'password' : 'text' }}"
                                                        class="form-control inpt-cnt" />
                                                </div>
                                                <div>
                                                    <span (click)="confirmPasswordVisibility()">
                                                        <i class="fas mx-3 eye-icon" [class.fa-eye]="!confirmPassword"
                                                            [class.fa-eye-slash]="confirmPassword"></i>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="my-3 mx-4">
                                                <button type="button" class="btnlogin mx-5">UPDATE</button>
                                            </div>
                                        </div>
                                        <div>
                                            <a (click)="forgotPassword()"
                                                class="text-primary forgot-password text-decoration-none mx-3">Forgot
                                                Password ? Update Using OTP</a>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="otpPassword && !showOtp">
                                    <div class="d-flex justify-content-center">
                                        <h2 class="text-primary header-style">Change Using OTP</h2>
                                    </div>

                                    <div class="d-flex justify-content-center">
                                        <button type="button"
                                            class="upload-btnactyvtyside btn btn-primary m-2 my-3 otp-btn">
                                            INITIATE OTP
                                        </button>
                                    </div>
                                    <div class="d-flex justify-content-center my-3">
                                        <p class="text-center label-cnt">
                                            OTP sent to your Mobile Number 9XX9X 0XX0X & to your email
                                            vxxxxxxxi@xxai.com
                                        </p>
                                    </div>
                                    <div class="my-5 otp-cnt">
                                        <div class="d-flex justify-content-center">
                                            <div>
                                                <label class="form-label">Enter OTP</label>
                                                <div class="input-group d-flex gap-3">
                                                    <input type="text" maxlength="1"
                                                        class="small-spacing otp-input mb-3" autofocus />
                                                    <input type="text" maxlength="1"
                                                        class="small-spacing otp-input mb-3" />
                                                    <input type="text" maxlength="1"
                                                        class="small-spacing otp-input mb-3" />
                                                    <input type="text" maxlength="1"
                                                        class="small-spacing otp-input mb-3" />
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <p class="text-center">You can resend OTP in 60 seconds</p>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <button type="button"
                                                class="upload-btnactyvtyside btn btn-primary verify-btn m-2"
                                                (click)="showOtp = true">
                                                VERIFY
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="my-4" *ngIf="showOtp">
                                    <h1 class="header-style mx-5">OTP Verified.Change Password</h1>
                                    <div class="change-password my-3 mx-5">
                                        <div class="col-12 d-flex flex-column mx-4">
                                            <div class="mb-3 d-flex">
                                                <div>
                                                    <label class="form-label label-cnt">New Password</label>
                                                    <input class="form-control inpt-cnt"
                                                        type="{{ newPassword ? 'password' : 'text' }}" />
                                                </div>
                                                <div>
                                                    <span (click)="newPasswordVisibility()">
                                                        <i class="fas mx-3 eye-icon" [class.fa-eye]="!newPassword"
                                                            [class.fa-eye-slash]="newPassword"></i>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="d-flex">
                                                <div>
                                                    <label class="form-label label-cnt"> Confirm Password</label>
                                                    <input type="{{ confirmPassword ? 'password' : 'text' }}"
                                                        class="form-control inpt-cnt" />
                                                </div>
                                                <div>
                                                    <span (click)="confirmPasswordVisibility()">
                                                        <i class="fas mx-3 eye-icon" [class.fa-eye]="!confirmPassword"
                                                            [class.fa-eye-slash]="confirmPassword"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="my-3 mx-4">
                                                <button type="button" class="btnlogin mx-5">UPDATE</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>